;(function () {
  const initCardList = () => {
    const texts = document.querySelectorAll('.card-list__text')
    const images = document.querySelectorAll('.card-list__item_img_active')
    const items = document.querySelectorAll('.card-list__item_active')
    for (let i = 0; i < texts.length; i++) {
      const textHeight = texts[i].offsetHeight
      if (window.matchMedia('(min-width: 990px)').matches) {
        images[i].style.height = '100%'
        items[i].addEventListener('mouseenter', () => {
          if (window.matchMedia('(min-width: 990px)').matches) {
            images[i].style.height = `calc(100% - ${textHeight}px)`
          }
        })
        items[i].addEventListener('mouseleave', () => {
          if (window.matchMedia('(min-width: 990px)').matches) {
            images[i].style.height = '100%'
          }
        })
      } else {
        images[i].style.height = `calc(100% - ${textHeight}px)`
      }
    }
  }
  document.addEventListener('DOMContentLoaded', function () {
    initCardList()
    document.addEventListener('shopify:section:load', function () {
      initCardList()
    })
  })
  window.addEventListener('resize', function () {
    initCardList()
  })
})()

;(function () {
  function updateSwiperClasses(section) {
    const cardList = section.querySelector('.card-list')
    const list = section.querySelector('.card-list__list')
    const items = section.querySelectorAll('.card-list__item')
    if (window.innerWidth <= 576) {
      cardList.classList.add('swiper')
      list.classList.add('swiper-wrapper')
      items.forEach(item => item.classList.add('swiper-slide'))
    } else {
      cardList.classList.remove('swiper')
      list.classList.remove('swiper-wrapper')
      items.forEach(item => item.classList.remove('swiper-slide'))
      cardList.removeAttribute('style')
      list.removeAttribute('style')
      items.forEach(item => item.removeAttribute('style'))
    }
  }
  const cardListInit = () => {
    $('.card-list-section').each(function () {
      updateSwiperClasses(this)
      const id = $(this).attr('id')
      const box = $(this).find('.card-list')
      const autoplay = box.data('autoplay')
      const stopAutoplay = box.data('stop-autoplay')
      const delay = 4 * 1000
      let autoplayParm = {}
      if (autoplay) {
        autoplayParm = {
          autoplay: {
            delay: delay,
            pauseOnMouseEnter: stopAutoplay,
            disableOnInteraction: false,
          },
        }
      }
      if (window.innerWidth <= 576) {
        const swiperInstance = $(this).data('swiperInstance')
        if (swiperInstance && typeof swiperInstance.destroy === 'function') {
          swiperInstance.destroy(true, true)
          $(this).removeData('swiperInstance')
        }
        const swiperParms = {
          slidesPerView: 1,
          loop: false,
          spaceBetween: 16,
          autoHeight: false,
          calculateHeight: false,
          keyboard: true,
          pagination: {
            el: `#${id} .swiper-pagination`,
            clickable: true,
            type: 'bullets',
          },
          ...autoplayParm,
        }
        const instance = new Swiper(`#${id} .swiper`, swiperParms)
        $(this).data('swiperInstance', instance)
      } else {
        const swiperInstance = $(this).data('swiperInstance')
        if (swiperInstance && typeof swiperInstance.destroy === 'function') {
          swiperInstance.destroy(true, true)
          $(this).removeData('swiperInstance')
        }
      }
    })
  }
  document.addEventListener('DOMContentLoaded', function () {
    cardListInit()
    document.addEventListener('shopify:section:load', function () {
      cardListInit()
    })
    window.addEventListener('resize', function () {
      cardListInit()
    })
  })
})()



//;(function () {
//	let swiperMulticolumn
//	const multicolumnSwipeEnabled = document.querySelector('.card-list-section')
//	const initSlider = () => {
//		multicolumnSwipeEnabled.classList.add('multicolumn-swiper-wrapper')
//		const slides = document.querySelectorAll('.card-list__item')
//		slides.forEach((slide) => {
//			slide.classList.add('swiper-slide')
//		})
//		swiperMulticolumn = new Swiper('.card-list-section', {
//			loop: false,
//			slidesPerView: 1,
//			spaceBetween: 0,
//			pagination: {
//				el: '.swiper-pagination',
//				clickable: true,
//				type: 'bullets',
//			},
//			breakpoints: {
//				576: {
//					slidesPerView: 2,
//				},
//			},
//		})
//	}
//	const destroySlider = () => {
//		multicolumnSwipeEnabled.classList.remove('multicolumn-swiper-wrapper')
//		const slides = document.querySelectorAll('.card-list__item')
//		swiperMulticolumn.destroy(true, true)
//		swiperMulticolumn = undefined
//		slides.forEach((slide) => {
//			slide.removeAttribute('style')
//			slide.classList.remove('swiper-slide')
//		})
//	}
//	const initMulticolumn = () => {
//		const multicolumnSection = document.querySelector('.card-list-section')
//		const sectionResizeObserver = new ResizeObserver((entries) => {
//			const [entry] = entries
//			if (entry.contentRect.width < 576 && multicolumnSwipeEnabled) {
//				initSlider()
//			} else if (swiperMulticolumn) {
//				destroySlider()
//			}
//		})
//		sectionResizeObserver.observe(multicolumnSection)
//	}
//	if (swiperMulticolumn) {
//		destroySlider()
//	}
//	initMulticolumn()
//	document.addEventListener('shopify:section:load', function () {
//		if (swiperMulticolumn) {
//			destroySlider()
//		}
//		initMulticolumn()
//	})
//})()
